import { createContext, useState, type FC, type ReactNode } from 'react'

interface IsDesktopFooterVisibleState {
  isVisible: boolean
  setIsVisible: (isVisible: boolean) => void
}

export const IsDesktopFooterVisibleContext =
  createContext<IsDesktopFooterVisibleState>({
    setIsVisible: () => null,
    isVisible: false,
  })

const IsDesktopFooterVisibleProvider: FC<{
  children?: ReactNode
}> = ({ children }) => {
  const [isVisible, setIsVisible] = useState(false)

  return (
    <IsDesktopFooterVisibleContext.Provider
      value={{
        isVisible,
        setIsVisible,
      }}
    >
      {children}
    </IsDesktopFooterVisibleContext.Provider>
  )
}

export default IsDesktopFooterVisibleProvider
